export const projectName = 'sigma'

export const states = {
  empty: 'empty',
  ready: 'ready',
  loading: 'loading',
  error: 'error',
  success: 'success'
}
